<template>
  <div
    ref="phoneVerificationModal"
    class="modal modal-v modal-v--normal fade"
    id="phoneVerificationModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="phoneVerificationModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" class="close " data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body d-flex flex-column align-items-center justify-content-start">
          <h2 class="title title--medium mb-3 mt-5 mt-md-0">{{ trans.get('profile:edit.phone_verification_modal.header') }}</h2>

          <ResponseComponent :response="response" class="text-center mb-3 desc desc--lightgrey"></ResponseComponent>

          <div v-show="step===1" class="modal-steps modal-step1">
            <form ref="modalStep1" @submit.prevent="sendStep1" id="form-step1">
              <div class="desc desc--medium text-center mb-5">
                <label for="phone_prefix">{{ trans.get('profile:edit.phone_verification_modal.enter_phone_number_label') }}</label>
              </div>
              <div class="form-row">
                <div class="col-auto">
                  <div class="selectdiv selectdiv--autosize">
                    <select v-model="form.phonePrefix" class="form-control">
                      <option v-for="v,k in globals.user.phone_prefixes" :value="k">{{ v }}</option>
                    </select>
                  </div>
                </div>
                <div class="col">
                  <input v-model="form.phone" id="phone" class="input-text__underline js-only-digits" name="phone" minlength="9" maxlength="12" required>
                </div>
              </div>
            </form>
          </div>
          <div v-show="step===2" class="modal-steps modal-step2">
            <form @submit.prevent="sendStep2" id="form-step2">
              <div class="desc desc--medium text-center mb-3">
                <label for="phone_verification_code" class="text-center">{{ trans.get('profile:edit.phone_verification_modal.enter_verification_code_label') }}</label>
              </div>
              <div class="modal__verification-phone-code">
                <input
                  v-model="form.phoneVerificationCode"
                  type="text" id="phone_verification_code" name="phone_verification_code" minlength="7"
                  maxlength="9" class="form-control" v-input-mask data-inputmask-mask="* * * *"
                  data-inputmask-placeholder="_ _ _ _" data-inputmask-clearMaskOnLostFocus="false"
                >
              </div>
            </form>
          </div>
          <button
            v-show="step===1"
            form="form-step1"
            type="submit"
            class="btn button button__fill mx-auto mt-5 mb-3"
          >
            {{ trans.get('profile:edit.phone_verification_modal.next_button') }}
          </button>

          <button
            v-show="step===2"
            form="form-step2"
            type="submit"
            class="button button__fill mx-auto mt-5 mb-3"
            style="display: none"
          >
            {{ trans.get('profile:edit.phone_verification_modal.verify_button') }}
          </button>

          <div class="d-flex justify-content-between align-content-center">
            <button
              v-show="step===2"
              @click="step=1"
              type="button"
              class="button button__link button__link--underline mx-auto mb-3 pr-3"
            >
              {{ trans.get('profile:edit.phone_verification_modal.back_button') }}
            </button>
            <button type="button" class="button button__link mx-auto mb-3" data-dismiss="modal">
              {{ trans.get('profile:edit.phone_verification_modal.close_button') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import HandleResponse from '../../scripts/vueHandleResponseErrors'
import ResponseComponent from '../ResponseComponent'

export default {
  name: 'PhoneVerificationModal',
  components: { ResponseComponent },
  mixins: [HandleResponse],
  props: {},
  data() {
    return {
      open: false,
      step: 1,
      form: {
        phonePrefix: null,
        phone: null,
        phoneVerificationCode: null,
      },
    }
  },
  computed: {},
  watch: {
    open(val) {
      if (val) {
        this.step = 1;
        this.form.phonePrefix = Object.keys(this.globals.user.phone_prefixes)[0];

        $(this.$refs.phoneVerificationModal).modal('show');
      } else {
        this.$eventHub.$emit('FreshPhoneEmail');
        $(this.$refs.phoneVerificationModal).modal('hide');
      }
    },
  },
  methods: {
    sendStep1: function () {
      axios
        .post(zRoute('ajax.verification.phone.send_code'), {
          phone: this.form.phonePrefix + ' ' + this.form.phone
        })
        .then(() => {
          this.step = 2;
        })
        .catch((error) => {
          this.handleResponseErrors(error.response.data);
        });
    },
    sendStep2: function () {
      axios
        .post(zRoute('ajax.verification.phone.check_code'), {
          phone_verification_code: this.form.phoneVerificationCode,
          phone: this.form.phonePrefix + ' ' + this.form.phone
        })
        .then(() => {
          this.open = false;
        })
        .catch((error) => {
          this.handleResponseErrors(error.response.data);
        });
    },
  },
  mounted() {
    this.$eventHub.$on('PhoneVerificationModalOpen', () => {
      this.open = true;
    });

    $(this.$refs.phoneVerificationModal).on('hidden.bs.modal', () => {
      this.open = false;
    });
  }
};
</script>

<style scoped>

</style>
